import { LANG_CODES_TO_TLD, LANG_CODES } from "../general_utils"

// types
import { SingleHrefLangMetaDataSet } from "../../../gatsby-node"

export const staticHrefLangTags = (
  path: string
): { [langCode: string]: SingleHrefLangMetaDataSet } => {
  const result: { [langCode: string]: SingleHrefLangMetaDataSet } = {}
  Object.keys(LANG_CODES_TO_TLD).forEach((langCode) => {
    const lowerCasedLocale = langCode?.toLowerCase()
    const tld = LANG_CODES_TO_TLD[langCode as LANG_CODES]
    const beginPathHandle = path?.startsWith("/") ? path : `/${path}`
    const handledPath = beginPathHandle?.endsWith("/")
      ? beginPathHandle
      : `${beginPathHandle}/`

    result[lowerCasedLocale] = {
      rel: "alternate",
      hreflang: lowerCasedLocale,
      href: `https://www.${process.env.GATSBY_BASE_HOST_NAME?.replace(
        ".com",
        ""
      )?.trim()}${tld}/help/${lowerCasedLocale}${handledPath}`
    }
  })
  return result
}
